import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseHttpService } from './base-http.service';

@Injectable({
  providedIn: 'root'
})
export class CrashService extends BaseHttpService {
  
  getCrashesInfo(plate: string): Observable<any> {
    return this.get<any>(`${environment.flettrackApi}/api/crashesInfo/${plate}`);
  }
}